import React from 'react';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import fr from 'facet-rest';
import KabobMenuItem from 'Views/Page/Content/Templates/WhatIfTemplate/Components/KabobMenu/KabobMenuItem';

const ClickToSyncKabobItem = () => {
  const { pageContentResource, loadPageContentLink } = usePageContentContext();

  const handleUpdateScenarioClick = () => {
    const updateLink = pageContentResource?.relationship(fr.relationships.clickToSync.name).link('related');
    if (!updateLink) {
      return;
    }
    loadPageContentLink(updateLink);
  };

  return (
    <KabobMenuItem
      label={'Update Scenario'}
      test={'facet-plan-summary-kabob-item-click-to-sync'}
      onClick={() => {
        handleUpdateScenarioClick();
      }}
    />
  );
};

ClickToSyncKabobItem.defaultProps = {};

ClickToSyncKabobItem.propTypes = {};

export default ClickToSyncKabobItem;
